import IconButton from '@mui/material/IconButton';
import {alpha, css, styled} from '@mui/material/styles';

const isHapTheme = (themeName: string) => themeName === 'hap';

export const Token = styled(IconButton)`
	font-size: 14px;
	padding: 8px;
	color: white;
	display: flex;
	flex-direction: column;
	margin-left: auto;

	${({theme}) => theme.breakpoints.down('sm')} {
		font-size: 12px;
	}

	&:is(&, :active, :focus) {
		${({theme}) => {
			const hap = isHapTheme(theme.name);

			return css`
				background-color: ${alpha(theme.palette.common.white, hap ? 0.16 : 0.56)};
				color: ${hap ? theme.palette.common.white : theme.palette.common.black};
			`;
		}}
	}
`;
